// Adhoc_Nor1.jsx
import React from 'react';
import { ActivityIndicator, ScrollView, Text, useWindowDimensions, View } from 'react-native';
import { useSelector } from 'react-redux';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import CustomPressable from '../../components/customPressable/customPressable';
import { ImageComp } from '../../components/Image/Image';
import RenderHTML from 'react-native-render-html';
import { getStyleForRenderHTML } from '../../js/utility';


const Adhoc_Nor1 = (props) => {
    const { adhocDataListLocalCopy, handleSkip, pendingOfferIds, acceptedOfferIds, handleOfferSelect } = props;

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const { width } = useWindowDimensions();

    const customGuestRequestTitleStyle = getStyles(['adhocOfferListItemHeaderTitleText']);
    const customGuestRequestSubTitleStyle = getStyles(['adhocOfferListItemHeaderSubTitleText']);

    const { baseStyle: titleBaseStyle, systemFonts: titleSystemFonts } = getStyleForRenderHTML(customGuestRequestTitleStyle);
    const { baseStyle: subtitleBaseStyle, systemFonts: subtitleSystemFonts } = getStyleForRenderHTML(customGuestRequestSubTitleStyle);

    const allOffers = adhocDataListLocalCopy?.flatMap(upsell =>
        upsell?.upsellOffers?.flatMap(upsellOffer =>
            upsellOffer?.offers || []
        ) || []
    ) || [];

    if (allOffers.length === 0) return null;

    return (
        <>
            <ScrollView
                automaticallyAdjustKeyboardInsets={true}
                contentContainerStyle={getStyles(['widgetmainContainer', 'adhocMainContainer'])}
                showsVerticalScrollIndicator={false}
            >
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'adhocHeaderContainer'])}>
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'adhocHeaderTitleContainer'])}>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'adhocHeaderTitle'])}>{t('adhoc.heading')}</Text>
                        <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'adhocHeaderSubTitle'])}>{t('adhoc.sub_heading')}</Text>
                    </View>
                </View>

                <View
                    style={getStyles(['widgetmainContainerChildContainer', 'adhocMainContainerChildContainer'])}
                    id='widgetmainContainerChildContainer adhocMainContainerChildContainer'
                >
                    {allOffers.map((offer, index) => {
                        const isPending = pendingOfferIds.includes(offer.offerId);
                        const isAccepted = acceptedOfferIds.has(offer.offerId);

                        return (
                            <View
                                key={`${offer.offerId ?? index}`}
                                style={getStyles(['adhocNor1ListItemContainer'])}
                                id='adhocNor1ListItemContainer'
                            >
                                {/* Top row: image + text */}
                                <View style={getStyles(['adhocOfferListItemSubHeaderContainer'])} id='adhocOfferListItemSubHeaderContainer'>
                                    <ImageComp
                                        source={offer?.images?.big || offer?.images?.small}
                                        style={getStyles(['', 'adhocOfferListItemSubHeaderImage'])}
                                        id='adhocOfferListItemSubHeaderImage'
                                    />
                                    <View
                                        style={getStyles(['', 'adhocOfferListItemHeaderTextContainer'])}
                                        id='adhocOfferListItemHeaderTextContainer'
                                    >
                                        <RenderHTML
                                            contentWidth={width}
                                            source={{ html: offer.title || '' }}
                                            baseStyle={titleBaseStyle}
                                            systemFonts={titleSystemFonts}
                                            id='adhocOfferListItemHeaderTitleText'
                                        />
                                        <RenderHTML
                                            contentWidth={width}
                                            source={{ html: offer.description || '' }}
                                            baseStyle={subtitleBaseStyle}
                                            systemFonts={subtitleSystemFonts}
                                            id='adhocOfferListItemHeaderTitleText'
                                        />
                                    </View>
                                </View>

                                {/* Bottom row: price + button */}
                                <View style={getStyles(['adhocOfferListItemOfferControlsContainer'])} id='adhocOfferListItemOfferControlsContainer'>
                                    <Text
                                        style={getStyles(['', 'adhocOfferListItemOfferControlsPrice'])}
                                        id='adhocOfferListItemOfferControlsPrice'
                                    >
                                        {currencyCode} {offer?.price?.amount}
                                    </Text>

                                    <View style={getStyles(['adhocOfferListButtonsContainer'])} id='adhocOfferListButtonsContainer'>
                                        {isPending ? (
                                            <View style={getStyles(['primaryBtn', 'adhocOfferListButtons'])} id='adhocOfferListButtons'>
                                                <ActivityIndicator size="small" color="#fff" />
                                                <Text style={getStyles(['primaryBtnTxt', 'adhocOfferListButtonsText'])} id='primaryBtnTxt adhocOfferListButtonsText'>
                                                    {t('adhoc.accepting')}
                                                </Text>
                                            </View>
                                        ) : isAccepted ? (
                                            // ✅ Accepted offer dikhao, button disabled
                                            <CustomPressable
                                                disabled
                                                style={getStyles(['primaryBtn', 'adhocOfferListButtons'])}
                                                id='adhocOfferListButtons adhocOfferListButtonsDisabled'
                                            >
                                                <Text style={getStyles(['primaryBtnTxt', 'adhocOfferListButtonsText'])} id='primaryBtnTxt adhocOfferListButtonsText'>
                                                    {t('adhoc.accepted')}
                                                </Text>
                                            </CustomPressable>
                                        ) : (
                                            <CustomPressable
                                                style={getStyles(['primaryBtn', 'adhocOfferListButtons'])}
                                                id='primaryBtn adhocOfferListButtons'
                                                onPress={() => handleOfferSelect(offer)}
                                                disabled={isPending}
                                            >
                                                <Text style={getStyles(['primaryBtnTxt', 'adhocOfferListButtonsText'])} id='primaryBtnTxt adhocOfferListButtonsText'>
                                                    {t('adhoc.accept')}
                                                </Text>
                                            </CustomPressable>
                                        )}
                                    </View>
                                </View>
                            </View>
                        );
                    })}
                </View>
            </ScrollView>

            <View style={getStyles(['footerButtonContainer'])} id="footerButtonContainer">
                <CustomPressable style={getStyles(['primaryBtn', 'adhocOfferListButtonsPrimary'])} onPress={handleSkip}>
                    <Text style={getStyles(['primaryBtnTxt', 'adhocOfferListButtonsPrimaryText'])}>{t('adhoc.continue')}</Text>
                </CustomPressable>
            </View>
        </>
    );
};

export default Adhoc_Nor1;